import praiseLogo from "@/assets/praise-logo.png";

interface PraiseLogoProps {
  size?: number;
  className?: string;
}

const PraiseLogo = ({ size = 32, className = "" }: PraiseLogoProps) => (
  <img
    src={praiseLogo}
    alt="Praise"
    width={size}
    height={size}
    className={`object-contain ${className}`}
  />
);

export default PraiseLogo;
